import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import routes from '../../common/models/route-constants';
import NotFoundPage from '../../common/pages/NotFoundPage';
import CreateIconPage from '../pages/CreateIconPage';
import IconHomePage from '../pages/IconHomePage';
import UpdateIconPage from '../pages/UpdateIconPage';

function IconAssetsRouter() {
    let { path } = useRouteMatch();
    return (
        <React.Fragment>
            <Switch>
                <Route exact path={`${path}`}>
                    <IconHomePage />
                </Route>
                <Route exact path={`${path}/${routes.CREATE}`}>
                    <CreateIconPage />
                </Route>
                <Route exact path={`${path}/:id`}>
                    <UpdateIconPage />
                </Route>
                <Route path='*'>
                    <NotFoundPage />
                </Route>
            </Switch>
        </React.Fragment>
    );
}

export default IconAssetsRouter;
